// extracted by mini-css-extract-plugin
module.exports = {"textAndSubtitleWrapper":"textAndSubtitle_textAndSubtitleWrapper__QehZz","title":"textAndSubtitle_title__Vql2Q","subtitle":"textAndSubtitle_subtitle__80jV4"};